// This file was generated using `pay js:run gql-v1 --type=lazy-query --name=RetrieveAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import type {
  V1LazyQueryOptionsWithoutVariables,
  V1LazyQueryOptions,
  V1LazyQueryReturn,
  V1PermissionToken,
} from '@stripe-internal/data-v1/types';
import {useV1LazyQuery} from '@stripe-internal/data-v1';
import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1AccountInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';
import {stripeAccountArkFragment} from './stripeAccountArkFragment';

import type {StripeAccountArkFragmentData} from './stripeAccountArkFragment';
import {useV1LazyQueryWithRequirementsBetaHeader} from './injectBetaHeaderHelpers/queryHelpers';

const doc = gql`
  query RetrieveAccountQuery(
    $input: OpenapiGetV1AccountInput
    $v1Context: V1ContextInput!
  ) {
    v1Account(input: $input, v1Context: $v1Context) {
      id
      ...StripeAccountArkFragment
    }
  }

  ${stripeAccountArkFragment}
`;

export const retrieveAccountLazyQuery: RetrieveAccountLazyQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const retrieveAccountLazyQueryOptions: V1LazyQueryOptionsWithoutVariables<RetrieveAccountLazyQueryDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useRetrieveAccountLazyQuery(
  options: V1LazyQueryOptions<RetrieveAccountLazyQueryDocument> = {},
): V1LazyQueryReturn<RetrieveAccountLazyQueryDocument> {
  // eslint-disable-next-line @stripe-internal/data-v1/structure-operations
  return useV1LazyQueryWithRequirementsBetaHeader(
    useV1LazyQuery(
      retrieveAccountLazyQuery,
      Object.assign({}, retrieveAccountLazyQueryOptions, options),
    ),
  );
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetrieveAccountLazyQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1AccountInput>;
  v1Context: V1ContextInput;
}>;

export type RetrieveAccountLazyQueryData = {
  readonly __typename: 'Query';
  readonly v1Account: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccount'; readonly id: string},
    [StripeAccountArkFragmentData]
  > | null;
};

const retrieveAccountLazyQueryPermissions = {
  ...stripeAccountArkFragment.permissions,
} as const;

doc.permissions = retrieveAccountLazyQueryPermissions;

export type RetrieveAccountLazyQueryPermissions = V1PermissionToken<
  typeof retrieveAccountLazyQueryPermissions
>;

export type RetrieveAccountLazyQueryDocument = GraphQlDocument<
  RetrieveAccountLazyQueryData,
  RetrieveAccountLazyQueryVariables,
  RetrieveAccountLazyQueryPermissions
>;
